import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { SavedFilter } from './filter.service';
import { SaveAppliedFiltersDialogComponent } from './save-applied-filters-dialog.component';
import { ManageSavedFiltersDialogComponent } from './manage-saved-filters-dialog.component';

@Component({
  selector: 'uikit-saved-filters-menu',
  template: `
    <button
      mat-icon-button
      #menuTrigger
      color="primary"
      [matMenuTriggerFor]="menuRef"
      matTooltip="{{ 'FRONTEND.UIKIT.VA_FILTER.YOUR_BOOKMARKED_FILTERS' | translate }}"
    >
      <mat-icon>bookmark</mat-icon>
    </button>
    <mat-menu #menuRef="matMenu">
      <ng-container *ngIf="options | async as opts">
        <button mat-menu-item *ngFor="let option of opts" (click)="selection.emit(option)">
          <mat-icon>bookmark</mat-icon>
          {{ option.name }}
        </button>
        <hr *ngIf="opts.length > 0" />
      </ng-container>
      <button mat-menu-item color="primary" (click)="openSaveCurrentFiltersDialog()">
        <mat-icon>add_circle</mat-icon>
        {{ 'FRONTEND.UIKIT.VA_FILTER.SAVE_THIS_FILTER' | translate }}
      </button>
      <button mat-menu-item [disabled]="(options | async)?.length === 0" (click)="openManageSavedFiltersDialog()">
        <mat-icon>edit</mat-icon>
        {{ 'FRONTEND.UIKIT.VA_FILTER.MANAGE_FILTERS' | translate }}
      </button>
      <ng-container *ngIf="showFilterSharing">
        <mat-divider />
        <button mat-menu-item (click)="openImportFilterDialog()">
          <mat-icon>import_export</mat-icon>
          {{ 'FRONTEND.UIKIT.VA_FILTER.IMPORT_FILTER' | translate }}
        </button>
        <button mat-menu-item (click)="openExportFilterDialog()">
          <mat-icon>import_export</mat-icon>
          {{ 'FRONTEND.UIKIT.VA_FILTER.EXPORT_FILTER' | translate }}
        </button>
      </ng-container>
    </mat-menu>
  `,
  styleUrls: ['saved-filters-menu.component.scss'],
  standalone: false,
})
export class SavedFiltersMenuComponent {
  @Input() options: Observable<SavedFilter[]>;
  @Input() showFilterSharing? = false;
  @Output() selection = new EventEmitter<SavedFilter>();
  @Output() saveCurrentFilter = new EventEmitter();
  @Output() removeSavedFilter = new EventEmitter();
  @Output() exportFilterDialog = new EventEmitter();
  @Output() importFilterDialog = new EventEmitter();

  private saveAppliedFiltersDialogRef: MatDialogRef<SaveAppliedFiltersDialogComponent>;
  private manageSavedFiltersDialogRef: MatDialogRef<ManageSavedFiltersDialogComponent>;

  constructor(private dialog: MatDialog) {}

  openSaveCurrentFiltersDialog(): void {
    this.saveAppliedFiltersDialogRef = this.dialog.open(SaveAppliedFiltersDialogComponent, { width: '400px' });
    this.saveAppliedFiltersDialogRef.afterClosed().subscribe((name) => {
      this.saveCurrentFilter.emit(name);
    });
  }

  openManageSavedFiltersDialog(): void {
    this.manageSavedFiltersDialogRef = this.dialog.open(ManageSavedFiltersDialogComponent, { width: '500px' });
    this.manageSavedFiltersDialogRef.componentInstance.savedFilters = this.options;
    this.manageSavedFiltersDialogRef.componentInstance.removeSavedFilter.subscribe((name: string) => {
      this.removeSavedFilter.emit(name);
    });
  }

  openExportFilterDialog(): void {
    this.exportFilterDialog.emit();
  }

  openImportFilterDialog(): void {
    this.importFilterDialog.emit();
  }
}
